<template lang='pug'>
  r-form(
    no-submit
    ref='form'
    reset-text='reestablecer'
    v-bind='formProps'
    v-model='formData'
    @reset='reset'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import Translator from '@/services/translator'
  //
  import ProviderPaymentModel from '@/models/Purchase/PchProviderPayment'
  import ProviderPaymentFields from '@/views/Purchase/PchProviderPayment/PchProviderPaymentUpdateFields'
  //
  export default {
    components: {
      RForm,
    },
    computed: {

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      formProps () {
        return {
          fields: ProviderPaymentFields,
          title : `detalle de pago al proveedor #${this.$route.params.id}`
        }
      },
    },
    data() {
      return {
        formData: {}
      }
    },
    methods: {

      /**
       * Resets the object.
       */
      reset() {
        return this
          .toWait(true)
          .then(this.toFetch)
          .then(this.toWait)
      },

      /**
       * Sets the form data.
       *
       * @param      {<type>}  model   The model
       */
      setFormData(model) {
        this.formData = model.reset()
      },

      /**
       * Returns a fetch representation of the object.
       *
       * @return     {<type>}  Fetch representation of the object.
       */
      toFetch() {
        return ProviderPaymentModel
          .include([
            'g_user.hr_employee',
            'pch_provider',
            'pch_detail_provider_payments.pch_provider_debt_to_pay.pch_purchase_invoice',
            'pch_detail_provider_payments.pch_provider_debt_to_pay.pch_purchase_debit_note',
            'pch_provider_payment_pos_payment_types.pos_sale_payment_type',
          ])
          .find(this.$route.params.id)
          .then(this.setFormData)
      },

      /**
       * { function_description }
       *
       * @param      {boolean}  [value=false]  The value
       * @return     {<type>}   { description_of_the_return_value }
       */
      toWait(value = false) {
        return this
          .$refs
          .form
          .setWait(value)
      },
    },
    beforeMount () {
      this.setTitle('Detalle de pago a proveedor')
    },
    mounted() {
      this.reset()
    },
  }
</script>